import { arrayOf, number, string } from 'prop-types';
import React from 'react';

import Tabs from '../../generic/Tabs';
import Titled from '../../layout/Titled';
import HandoverButton from '../../opportunities/HandoverButton';
import { campaignStatusCountShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import { allListColumns, defaultListColumns } from '../campaign-columns';
import { allStatusesEnum } from '../constants';
import { AsyncList } from '../List';
import dump from '../utils/dump';

class ListCategorizedCampaigns extends React.PureComponent {
  state = {
    selectedCampaigns: [],
  };

  getSelectedItems = items => this.setState({ selectedCampaigns: items });

  getCount(status) {
    const { counts } = this.props;
    const countObject = counts.find(count => count.status === status);
    return countObject ? countObject.count : 0;
  }

  getList(status, columns, allowUIDownload = true) {
    const { brandIds, salesChannel } = this.props;
    const downloadProps = allowUIDownload
      ? { dump }
      : { displayExportButton: true };
    return (
      <AsyncList
        setSelectedItems={this.getSelectedItems}
        selectionName="campaigns"
        storedName="CAMPAIGNS_FILTERS"
        allowSelection
        columns={columns}
        allColumns={allListColumns}
        searchParams={{
          status,
          brandIds,
          salesChannel,
          opportunity__salesChannel: salesChannel,
        }}
        {...downloadProps}
      />
    );
  }

  statusLabel(status) {
    return `${status.label} (${this.getCount(status.value)})`;
  }

  filterHiddenColumns(columns) {
    const { hiddenColumns } = this.props;
    return columns.filter(col => !hiddenColumns.includes(col.Header));
  }

  tabs() {
    const { counts } = this.props;

    return [
      {
        label: `ALL (${counts
          .map(c => c.count)
          .reduce((acc, count) => acc + count, 0)})`,
        value: 'all',
        content: this.getList(
          [], // No status needs to be passed in query in 'All' tab
          this.filterHiddenColumns(defaultListColumns),
          false,
        ),
      },
      {
        label: this.statusLabel(allStatusesEnum.SETUP_PROGRESS),
        value: allStatusesEnum.SETUP_PROGRESS.value,
        content: this.getList(
          allStatusesEnum.SETUP_PROGRESS.value,
          this.filterHiddenColumns(defaultListColumns),
        ),
      },
      {
        label: this.statusLabel(allStatusesEnum.RUNNING),
        value: allStatusesEnum.RUNNING.value,
        content: this.getList(
          allStatusesEnum.RUNNING.value,
          this.filterHiddenColumns(defaultListColumns),
        ),
      },
      {
        label: this.statusLabel(allStatusesEnum.PAUSED),
        value: allStatusesEnum.PAUSED.value,
        content: this.getList(
          allStatusesEnum.PAUSED.value,
          this.filterHiddenColumns(defaultListColumns),
        ),
      },
      {
        label: this.statusLabel(allStatusesEnum.ENDED),
        value: allStatusesEnum.ENDED.value,
        content: this.getList(
          allStatusesEnum.ENDED.value,
          this.filterHiddenColumns(defaultListColumns),
        ),
      },
    ];
  }

  render() {
    const { title, titleSize } = this.props;
    return (
      <Titled
        title={title}
        size={titleSize}
        actions={
          <HandoverButton
            selectedItems={this.state.selectedCampaigns}
            itemsType="campaigns"
          />
        }
      >
        <Tabs
          tabs={this.tabs()}
          defaultActive={allStatusesEnum.RUNNING.label}
          id="categorizedCampaigns"
        />
      </Titled>
    );
  }
}

ListCategorizedCampaigns.propTypes = {
  title: string,
  titleSize: string,
  hiddenColumns: arrayOf(string.isRequired),
  counts: arrayOf(campaignStatusCountShape.isRequired).isRequired,
  brandIds: arrayOf(number),
  salesChannel: string,
};

ListCategorizedCampaigns.defaultProps = {
  title: 'Campaigns',
  titleSize: undefined,
  hiddenColumns: [],
  brandIds: [],
  salesChannel: undefined,
};

export default withResolved({
  query: api.getCampaignsCount,
  deriveQueryArgs: ({ brandIds, salesChannel }) => ({
    search: {
      brandIds,
      salesChannel,
      opportunity__salesChannel: salesChannel,
    },
  }),
  as: 'counts',
})(ListCategorizedCampaigns);
